<!-- Category Breakdown -->
<div class="bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-sm dark:shadow-slate-900/30 border border-gray-100 dark:border-slate-700">
  <!-- Header -->
  <div class="flex items-center gap-2 mb-6">
    <span class="text-2xl">🥧</span>
    <h3 class="text-lg font-bold text-gray-800 dark:text-gray-100">Répartition par catégorie</h3>
  </div>

  <!-- Loading State -->
  @if (isLoading) {
    <div class="flex items-center gap-6 animate-pulse">
      <div class="w-32 h-32 bg-gray-200 dark:bg-slate-700 rounded-full"></div>
      <div class="flex-1 space-y-3">
        @for (i of [1, 2, 3, 4]; track i) {
          <div
            class="h-4 bg-gray-200 dark:bg-slate-700 rounded w-full"
          ></div>
        }
      </div>
    </div>
  }

  <!-- Error State -->
  @if (error && !isLoading) {
    <div class="text-center py-8">
      <span class="text-3xl mb-2 block">⚠️</span>
      <p class="text-gray-500 dark:text-gray-400">{{ error }}</p>
    </div>
  }

  <!-- Content -->
  @if (!isLoading && !error && categories.length > 0) {
    <div
      class="flex flex-col md:flex-row items-center gap-6"
      >
      <!-- Donut Chart SVG -->
      <div class="relative w-40 h-40 flex-shrink-0">
        <svg viewBox="0 0 42 42" class="w-full h-full -rotate-90">
          <!-- Background circle -->
          <circle
            cx="21"
            cy="21"
            r="15.91549430918954"
            fill="transparent"
            stroke="#e5e7eb"
            stroke-width="4"
            />
            <!-- Segments -->
            @for (segment of getDonutSegments(); track segment; let i = $index) {
              <circle
                cx="21"
                cy="21"
                r="15.91549430918954"
                fill="transparent"
                [attr.stroke]="segment.color"
                stroke-width="4"
          [attr.stroke-dasharray]="
            segment.length + ' ' + (100 - segment.length)
          "
                [attr.stroke-dashoffset]="segment.offset"
                class="transition-all duration-500"
                />
            }
          </svg>
          <!-- Center text -->
          <div class="absolute inset-0 flex flex-col items-center justify-center">
            <span class="text-lg font-bold text-gray-900 dark:text-white">{{
              formatCurrency(totalRevenue)
            }}</span>
            <span class="text-xs text-gray-500 dark:text-gray-400">Total</span>
          </div>
        </div>
        <!-- Legend -->
        <div class="flex-1 space-y-3 w-full">
          @for (category of categories; track category; let i = $index) {
            <div
              class="flex items-center gap-3"
              >
              <!-- Color dot -->
              <div
                class="w-3 h-3 rounded-full flex-shrink-0"
                [ngClass]="getColor(i)"
              ></div>
              <!-- Category info -->
              <div class="flex-1 min-w-0">
                <div class="flex items-center justify-between">
                  <span class="font-medium text-gray-800 dark:text-gray-100 flex items-center gap-1">
                    {{ getCategoryIcon(category.category) }}
                    {{ category.category }}
                  </span>
                  <span class="font-bold text-gray-900 dark:text-white">{{
                    formatCurrency(category.revenue)
                  }}</span>
                </div>
                <!-- Progress bar -->
                <div class="mt-1 h-1.5 bg-gray-100 dark:bg-slate-800 rounded-full overflow-hidden">
                  <div
                    class="h-full rounded-full transition-all duration-500"
                    [ngClass]="getColor(i)"
                    [style.width]="formatPercentage(category.percentage)"
                  ></div>
                </div>
                <div
                  class="flex items-center justify-between mt-1 text-xs text-gray-500 dark:text-gray-400"
                  >
                  <span>{{ category.itemsSold }} articles</span>
                  <span>{{ formatPercentage(category.percentage) }}</span>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    }

    <!-- Empty State -->
    @if (!isLoading && !error && categories.length === 0) {
      <div
        class="text-center py-8"
        >
        <span class="text-4xl mb-2 block">📭</span>
        <p class="text-gray-500 dark:text-gray-400">Aucune donnée pour cette période</p>
      </div>
    }
  </div>
